import { render, staticRenderFns } from "./left-bottom.vue?vue&type=template&id=4542ff6f&scoped=true&"
import script from "./left-bottom.vue?vue&type=script&lang=js&"
export * from "./left-bottom.vue?vue&type=script&lang=js&"
import style0 from "./left-bottom.vue?vue&type=style&index=0&id=4542ff6f&scoped=true&lang=css&"
import style1 from "./left-bottom.vue?vue&type=style&index=1&id=4542ff6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542ff6f",
  null
  
)

export default component.exports